var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2823,
    cy: 20,
    rx: 20.2823,
    ry: 20,
    fill: "#28387E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3032 17.7847C27.3032 14.1225 24.2472 11.1538 20.4774 11.1538C16.7077 11.1538 13.6517 14.1225 13.6517 17.7847C13.6517 22.4369 13.6517 24.5646 13.6517 29.2307L20.8131 29.2307L20.8131 25.9696L17.0086 25.9696L17.0086 25.0372C17.0086 23.1761 18.5616 21.6674 20.4774 21.6674C22.3932 21.6674 23.9463 23.1761 23.9463 25.0372L23.9463 29.2307L27.3032 29.2307C27.3032 24.5646 27.3032 22.4369 27.3032 17.7847ZM17.0086 19.3252C18.0251 18.7414 19.211 18.4063 20.4774 18.4063C21.7439 18.4063 22.9298 18.7414 23.9463 19.3252L23.9463 17.7847C23.9463 15.9236 22.3932 14.4149 20.4774 14.4149C18.5616 14.4149 17.0086 15.9236 17.0086 17.7847L17.0086 19.3252Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3130317d215228ac66aec9c714c5544.svg";
export { ForwardRef as ReactComponent };